/**
 * @file 通用API函数
 * @author 小白
 */

import request from "@/utils/request";
import OSS from "ali-oss";
import axios from "axios";

export async function getRasKeyFn(data) {
  return request.post("/openApi/asymmetric/publicKey", data);
}

/**
 * 获取sdk 请求接口
 */
export async function sdkOssCredentials() {
  return request.post('/openApi/jsSdk/oss/credentials');
}


/**
 * 上传图片
 */
let client = null;
export async function sdkOssUpimage() {
  return new Promise((resolve, reject) => {
    // if (client) {
    //   resolve(client);
    // } else {
    sdkOssCredentials()
      .then((res) => {
        client = new OSS({
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          stsToken: res.securityToken,
          region: "oss-" + res.region,
          bucket: res.bucket,
          // 刷新临时访问凭证的时间间隔，单位为毫秒。半小时
          refreshSTSTokenInterval: 36000000,
          env: res.env,
        });
        resolve(client);
      })
      .catch((err) => {
        reject(err);
      });
    // }
  });
}


/**
 * 民族Json
 **/
export async function getNationJson() {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: 'https://beegoedujs.oss-cn-shenzhen.aliyuncs.com/nation/nation-1.0.json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}